import { createSectionTitle, createSummaryTitle, createTable, parseHtmlContent } from '../utils';

export const renderSurgicalHistory = (data, title) => {
  const content = [createSectionTitle(title)];

  // Handle noDetails case
  if (data && data.noDetails) {
    content.push({
      text: 'No details',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  // Helper function to check if surgical data is meaningful
  const hasValidSurgicalData = (data) => {
    if (!data || typeof data !== 'object') return false;

    const hasRows =
      data.row &&
      Array.isArray(data.row) &&
      data.row.some((surgery) => {
        const surgeryName = surgery.surgery
          ? surgery.surgery.label || surgery.surgery.value || surgery.surgery
          : '';
        const surgeonText = surgery.surgeon
          ? surgery.surgeon.label || surgery.surgeon.value || surgery.surgeon
          : '';

        return (
          (surgeryName && surgeryName.trim() !== '') ||
          (surgery.date && surgery.date.trim() !== '') ||
          (surgery.note && surgery.note.trim() !== '') ||
          (surgeonText && surgeonText.trim() !== '')
        );
      });

    const hasNarrative = data.narrative && data.narrative.trim() !== '';

    return hasRows || hasNarrative;
  };

  // Check if there's any meaningful data to display
  if (!hasValidSurgicalData(data)) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  if (data.row && Array.isArray(data.row)) {
    // Filter out empty rows
    const validRows = data.row.filter((surgery) => {
      const surgeryName = surgery.surgery
        ? surgery.surgery.label || surgery.surgery.value || surgery.surgery
        : '';
      const surgeonText = surgery.surgeon
        ? surgery.surgeon.label || surgery.surgeon.value || surgery.surgeon
        : '';

      return (
        (surgeryName && surgeryName.trim() !== '') ||
        (surgery.date && surgery.date.trim() !== '') ||
        (surgery.note && surgery.note.trim() !== '') ||
        (surgeonText && surgeonText.trim() !== '')
      );
    });

    if (validRows.length > 0) {
      const headers = ['Surgery', 'Date', 'Note', 'Surgeon'];
      const rows = validRows.map((surgery) => {
        const surgeryName = surgery.surgery
          ? surgery.surgery.label || surgery.surgery.value || surgery.surgery
          : '';
        const surgeonText = surgery.surgeon
          ? surgery.surgeon.label || surgery.surgeon.value || surgery.surgeon
          : '';

        return [
          { text: surgeryName || '-', style: 'tableCell' },
          { text: surgery.date || '-', style: 'tableCell' },
          { text: surgery.note || '-', style: 'tableCell' },
          { text: surgeonText || '-', style: 'tableCell' }
        ];
      });

      content.push(createTable(headers, rows, ['25%', '20%', '20%', '35%']));
    }
  }

  // Show narrative if it exists
  if (data.narrative && data.narrative.trim() !== '') {
    content.push(createSummaryTitle());
    content.push({
      text: parseHtmlContent(data.narrative),
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  // If no content was added beyond title, show "No data"
  if (content.length === 1) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  return content;
};
